<template>
    <div class="field_head" :class="{ 'cursor-pointer': can_sort }" @click="emitOrdering">
        <span v-if="!is_html">{{ field_name }}</span>
        <span v-else v-html="field_name"></span>
        
        <div class="badge badge-info" v-if="is_current_field_sort">
            <i :class="current_sort_class" class="fal opacity-100 color-white"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: "grid",
    
    props: {
        can_sort: {
            type: Boolean,
            default: true,
        },
        
        list_ordering: {
            type: String,
            required: true,
        },
        
        field_name: {
            type: String,
            required: true,
        },
        
        is_html: {
            type: Boolean,
            default: false,
        },
        
        current_ordering: {
            type: String,
            default: "",
        },
        
        current_direction: {
            type: String,
            default: "DESC",
        },
    },
    
    emits: ['update-order'],
    
    computed: {
        is_current_field_sort() {
            return this.current_ordering === this.list_ordering;
        },
        
        next_sort_direction() {
            if (this.is_current_field_sort) {
                return this.current_direction.toUpperCase() === "DESC" ? "ASC" : "DESC";
            }
            return "DESC";
        },
        
        current_sort_class() {
            if (!this.is_current_field_sort) return "";
            return this.current_direction.toUpperCase() === "DESC"
                ? "fa-arrow-alt-to-bottom"
                : "fa-arrow-alt-to-top";
        },
    },
    
    methods: {
        emitOrdering() {
            if (!this.can_sort) return;
            this.$emit('update-order', {
                ordering: this.list_ordering,
                direction: this.next_sort_direction
            });
        },
    }
};
</script>
